import { render, staticRenderFns } from "./VoteSummary.vue?vue&type=template&id=d56b55d2&"
import script from "./VoteSummary.vue?vue&type=script&lang=js&"
export * from "./VoteSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports